import { SearchTableActionAddListDialog } from '@aibees/elephant/components/search-table-action-dialog-lists/components/search-table-action-add-list-dialog';
import { SearchTableActionRemoveLabelDialog } from '@aibees/elephant/components/search-table-action-remove-label-dialog/search-table-action-remove-label-dialog';
import { useTableActionContext } from '@aibees/elephant/context';
import { LabelType } from '@aibees/elephant/types/label';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { QuickActionMenuItem } from '../quick-action-menu-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { QuickActionsButtonGroupListsMenuProps as Props } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'left',
} as const;

export const QuickActionsButtonGroupListsMenu = memo(
  ({ className, state, anchorEl, handleClose }: Props) => {
    const { listDialogState, removeListDialogState } = useTableActionContext();

    const handleCloseMainMenu = () => {
      state.onFalse();
    };

    const handleClickAddLists = () => {
      listDialogState.onTrue();
      handleClose?.();
    };

    const handleClickRemoveLists = () => {
      removeListDialogState.onTrue();
      handleClose?.();
    };

    return (
      <Styled.Wrapper
        className={classnames('QuickActionsButtonGroupListsMenu', className)}
        anchorEl={anchorEl}
        open={state.value}
        onClose={handleCloseMainMenu}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <Box sx={SX.root}>
          <QuickActionMenuItem
            title="Add/Create List"
            onClick={handleClickAddLists}
          />
          <QuickActionMenuItem
            title="Remove From Lists"
            onClick={handleClickRemoveLists}
          />
        </Box>

        <SearchTableActionAddListDialog />
        <SearchTableActionRemoveLabelDialog
          type={LabelType.LIST}
          titleHeader="Remove from List"
          title="Remove List"
          icon="list-remove"
        />
      </Styled.Wrapper>
    );
  }
);

QuickActionsButtonGroupListsMenu.displayName =
  'QuickActionsButtonGroupListsMenu';
